<template>
  <div class="mainRight pageContainer flexCloumn zphPage">
    <div v-if="companyInfo.check_status == 1 || (tableData && tableData.length > 0)" class="flexCloumn"
      style="width: 100%; height: 100%">
      <el-row class="searchBar flexBetween" style="flex-wrap: wrap; width: 100%">
        <el-button type="primary" icon="el-icon-plus" @click="add" size="small ">新增申请</el-button>

        <div class="flexEnd flex_1">
          <el-date-picker style="width: 180px" v-model="searchForm.year" size="small" type="year" value-format="yyyy"
            placeholder="招聘会年份" clearable></el-date-picker>

          <el-select v-model="searchForm.status" clearable placeholder="审核状态" size="small"
            style="width: 180px; margin-left: 10px">
            <el-option label="全部" value></el-option>
            <el-option label="审核中" :value="1"></el-option>
            <el-option label="审核通过" :value="2"></el-option>
            <el-option label="审核不通过" :value="3"></el-option>
          </el-select>
          <el-button icon="el-icon-search" style="margin-left: 10px" size="small" type="primary"
            @click="getList">搜索</el-button>
        </div>
      </el-row>
      <el-row v-if="!tableData || tableData.length == 0" class="flexCenter" style="width: 100%; padding: 40px 15px">
        <div style="text-align: center; color: #909399">
          <div>暂无数据~</div>
        </div>
      </el-row>
      <div class="flex_1" style="width: 100%; overflow-y: auto; padding: 0 15px">
        <ul class="list-items">
          <li class="list-item flexBetween" v-for="(p, idx) in tableData" :key="idx">
            <div class="list-content">
              <p :class="p.status == 1 || p.status == 3 ? 'name name1' : 'name'">
                {{ p.year }}年 线下招聘会
                <span v-if="p.status == 1" class="style0">审核中</span>
                <span v-if="p.status == 2" class="style1">审核通过</span>

                <el-tooltip class="item" effect="dark" :content="p.check_desc" placement="top-end">
                  <span v-if="p.status == 3" class="style2">审核不通过</span>
                </el-tooltip>

                <!-- <span v-if="p.status == 3" class="style3">已关闭</span> -->
              </p>
              <div class="flexStart" style="color: #909399; font-size: 14px">
                参会人员：<span v-for="(user, index) in p.delegates">{{ user.name || "-" }}&nbsp;</span>
              </div>
              <div style="color: #909399; font-size: 14px">
                招聘职位：<span v-for="(job, index) in p.job_info_list">{{ job.post || "-" }}&nbsp;</span>
              </div>
            </div>

            <div class="createdTime">{{ p.create_date }} 申请</div>

            <ul class="list-item-action felxStart">
              <li v-if="p.status == 3 || p.status == 1">
                <a @click="edit(p)" type="primary">编辑</a>
                <em class="list-item-action-split"></em>
              </li>
              <li v-if="p.status == 2">
                <a @click="view(p)" type="primary">查看</a>
                <em v-if="p.status == 1" class="list-item-action-split"></em>
              </li>
            </ul>
          </li>
        </ul>
      </div>

      <el-pagination @current-change="handlePageChange" @size-change="handleSizeChange"
        :current-page="page.current_page" :page-size="page.per_page" :total="page.count"
        layout="total, sizes,prev, pager, next" :page-sizes="[10, 20, 50, 100]" style="margin: 10px 0 0 15px">
      </el-pagination>
    </div>
    <el-row class="flexCenter" style="width: 100%">
      <div v-if="companyInfo.check_status != 1" style="text-align: center; color: orangered; padding: 15px">
        <div v-if="companyInfo.check_status == 2">您的企业认证失败：{{ companyInfo.remarks }}</div>
        <div v-if="companyInfo.check_status == 0">您的企业正在审核中，请耐心等待审核通过后即可发布岗位！</div>
      </div>
    </el-row>

    <el-dialog :visible.sync="dialogshow" :close-on-click-modal="false" :destroy-on-close="true"
      custom-class="cus_dialog cus_dialogMax" width="1200px">
      <div slot="title" class="flexBetween">
        <span style="color: #ffffff"><span style="font-weight: 700">{{ companyDetail.year || curYear }}年 校园招聘会</span></span>
      </div>
      <div style="padding: 20px; border-radius: 4px; text-align: center; width: 1000px; margin: 0 auto">
        <div class="row" style="border: 1px solid #ccc; border-left: 0">
          <div class="td" style="width: 100%">
            <div style="width: 100%">
              <div v-if="pmid != 220 || !headerInfo || !headerInfo.title">
                <strong style="font-size: 18px">{{ $store.state.config.schoolName_z }} 校园招聘会</strong>
                <br />参会回执
              </div>
              <div v-if="pmid == 220 && headerInfo && headerInfo.title">
                <strong style="font-size: 22px">{{ headerInfo.title }}</strong>
                <br /><span style="font-size: 20px">参会回执</span>
              </div>
              <div style="width: 1px; height: 1px; overflow: hidden">
                <div id="printMe"
                  style="padding: 20px; border-radius: 4px; text-align: center; width: 1000px; margin: 0 auto">
                  <div v-if="pmid != 220 || !headerInfo || !headerInfo.title"
                    style="height: 50px; text-align: center; font-size: 20px; font-weight: bolder">校园招聘会</div>
                  <div v-if="pmid != 220 || !headerInfo || !headerInfo.title" style="height: 50px; text-align: center">
                    参会回执</div>
                  <div v-if="pmid == 220 && headerInfo && headerInfo.title"
                    style="height: 50px; text-align: center; font-size: 22px; font-weight: bolder">{{ headerInfo.title
                    }}</div>
                  <div v-if="pmid == 220 && headerInfo && headerInfo.title"
                    style="height: 50px; text-align: center;font-size: 20px">
                    参会回执</div>
                  <table class="dttable">
                    <tr v-if="pmid == 220">
                      <td>活动时间</td>
                      <td> {{ headerInfo.time }} </td>
                      <td>活动地点</td>
                      <td>{{ headerInfo.address }}</td>
                    </tr>
                    <tr>
                      <td style="width: 15%">单位名称</td>
                      <td style="width: 55%"> {{ companyDetail.firm_name }} </td>
                      <td style="width: 15%">单位性质</td>
                      <td colspan="3">{{ qyxz[companyDetail.info] ? qyxz[companyDetail.info].param_desc :
                        companyDetail.tyc && companyDetail.tyc.enter_type ? companyDetail.tyc.enter_type : "-" }}</td>
                    </tr>
                    <tr v-if="pmid != 220">
                      <td>单位地址</td>
                      <td colspan="3">{{ companyDetail.address }}</td>
                      <td>邮政编码</td>
                      <td>{{ companyDetail.postal_code }}</td>
                    </tr>
                    <tr v-if="pmid == 220">
                      <td>单位地址</td>
                      <td colspan="5">{{ companyDetail.address }}</td>
                    </tr>
                    <tr v-if="pmid != 220">
                      <td style="width: 15%">单位联系部门</td>
                      <td style="width: 20%">
                        {{ companyDetail.contact_dept }}
                      </td>
                      <td style="width: 15%">联系人</td>
                      <td style="width: 20%">
                        {{ companyDetail.firm_principal }}
                      </td>
                      <td style="width: 15%">电话</td>
                      <td style="width: 15%">{{ companyDetail.tel }}</td>
                    </tr>
                    <tr v-if="pmid == 220">
                      <td style="width: 15%">联系人</td>
                      <td style="width: 35%">
                        {{ companyDetail.firm_principal }}
                      </td>
                      <td style="width: 15%">电话</td>
                      <td style="width: 35%">{{ companyDetail.tel }}</td>
                    </tr>
                    <tr v-if="pmid != 220">
                      <td style="width: 15%">传 真</td>
                      <td style="width: 20%">{{ companyDetail.fax }}</td>
                      <td style="width: 15%">电子邮箱</td>
                      <td style="width: 20%">{{ companyDetail.email }}</td>
                      <td style="width: 15%">参会人数</td>
                      <td style="width: 15%">{{ companyDetail.num }}</td>
                    </tr>
                    <tr v-if="pmid == 220">
                      <td style="width: 15%">电子邮箱</td>
                      <td colspan="5" style="width: 85%">{{ companyDetail.email }}</td>
                    </tr>
                    <tr>
                      <td>企业简介</td>
                      <td colspan="5">
                        <div style="min-height: 150px; text-align: left">
                          {{ companyDetail.job_desc }}
                        </div>
                      </td>
                    </tr>
                    <tr>
                      <td colspan="6">参会代表情况</td>
                    </tr>
                    <tr>
                      <td colspan="6" style="padding: 0">
                        <table class="dttable" style="border: 0">
                          <tr v-if="pmid != 220">
                            <td style="width: 15%; border: 0; border-bottom: 1px solid #000">姓名</td>
                            <td
                              style="width: 20%; border: 0; border-left: 1px solid #000; border-bottom: 1px solid #000">
                              性别</td>
                            <td
                              style="width: 15%; border: 0; border-left: 1px solid #000; border-bottom: 1px solid #000">
                              职务</td>
                            <td
                              style="width: 20%; border: 0; border-left: 1px solid #000; border-bottom: 1px solid #000">
                              办公电话</td>
                            <td
                              style="width: 15%; border: 0; border-left: 1px solid #000; border-bottom: 1px solid #000">
                              移动电话</td>
                          </tr>
                          <tr v-if="pmid == 220">
                            <td style="width: 25%; border: 0; border-bottom: 1px solid #000">姓名</td>
                            <td
                              style="width: 25%; border: 0; border-left: 1px solid #000; border-bottom: 1px solid #000">
                              性别</td>
                            <td
                              style="width: 25%; border: 0; border-left: 1px solid #000; border-bottom: 1px solid #000">
                              职务</td>
                            <td
                              style="width: 25%; border: 0; border-left: 1px solid #000; border-bottom: 1px solid #000">
                              移动电话</td>
                          </tr>
                          <tr v-if="pmid != 220" v-for="(item, idx) in dbList" :key="idx + 100">
                            <td style="width: 15%; border: 0">
                              {{ item.name }}
                            </td>
                            <td style="width: 20%; border: 0; border-left: 1px solid #000">
                              {{ item.sex == 1 ? "男" : "女" }}
                            </td>
                            <td style="width: 15%; border: 0; border-left: 1px solid #000">
                              {{ item.job }}
                            </td>
                            <td style="width: 20%; border: 0; border-left: 1px solid #000">
                              {{ item.officePhone }}
                            </td>
                            <td style="width: 15%; border: 0; border-left: 1px solid #000">
                              {{ item.mobilePhone }}
                            </td>
                          </tr>
                          <tr v-if="pmid == 220" v-for="(item, idx) in dbList" :key="idx + 100">
                            <td style="width: 25%; border: 0">
                              {{ item.name }}
                            </td>
                            <td style="width: 25%; border: 0; border-left: 1px solid #000">
                              {{ item.sex == 1 ? "男" : "女" }}
                            </td>
                            <td style="width: 25%; border: 0; border-left: 1px solid #000">
                              {{ item.job }}
                            </td>

                            <td style="width: 25%; border: 0; border-left: 1px solid #000">
                              {{ item.mobilePhone }}
                            </td>
                          </tr>
                        </table>
                      </td>
                    </tr>

                    <tr>
                      <td colspan="6">毕业生需求信息登记表</td>
                    </tr>
                    <tr>
                      <td colspan="6" style="padding: 0">
                        <table class="dttable" style="border: 0">
                          <tr>
                            <td style="width: 16.5%; border: 0; border-bottom: 1px solid #000">招聘职位</td>
                            <td
                              style="width: 16.5%; border: 0; border-left: 1px solid #000; border-bottom: 1px solid #000">
                              所需人数</td>
                            <td
                              style="width: 16.5%; border: 0; border-left: 1px solid #000; border-bottom: 1px solid #000">
                              专业要求</td>
                            <td
                              style="width: 16.5%; border: 0; border-left: 1px solid #000; border-bottom: 1px solid #000">
                              学历要求</td>
                            <td
                              style="width: 16.5%; border: 0; border-left: 1px solid #000; border-bottom: 1px solid #000">
                              外语要求</td>
                            <td
                              style="width: 16.5%; border: 0; border-left: 1px solid #000; border-bottom: 1px solid #000">
                              计算机要求</td>
                          </tr>
                          <tr v-for="(item, idx) in gwList" :key="idx">
                            <td style="width: 16.5%; border: 0">
                              {{ item.post }}
                            </td>
                            <td style="width: 16.5%; border: 0; border-left: 1px solid #000">
                              {{ item.num }}
                            </td>
                            <td style="width: 16.5%; border: 0; border-left: 1px solid #000">
                              {{ item.specialty }}
                            </td>
                            <td style="width: 16.5%; border: 0; border-left: 1px solid #000">
                              {{ item.culture }}
                            </td>
                            <td style="width: 16.5%; border: 0; border-left: 1px solid #000">
                              {{ item.foreignLanguage }}
                            </td>
                            <td style="width: 16.5%; border: 0; border-left: 1px solid #000">
                              {{ item.computer }}
                            </td>
                          </tr>
                        </table>
                      </td>
                    </tr>
                  </table>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div v-if="pmid == 220" class=" row">
          <div class="td" style="width: 15%">活动时间</div>
          <div class="td" style="width: 55%; text-align: left">
            {{ headerInfo.time }}
          </div>
          <div class="td" style="width: 15%">活动地点</div>
          <div class="td rltd" style="width: 15%">
            {{ headerInfo.address }}

          </div>
        </div>
        <div class="row">
          <div class="td" style="width: 15%">单位名称</div>
          <div class="td" style="width: 55%; text-align: left">
            {{ companyDetail.firm_name }}
          </div>
          <div class="td" style="width: 15%">单位性质</div>
          <div class="td rltd" style="width: 15%">
            <!-- {{ companyDetail.info}} -->
            {{ qyxz[companyDetail.info] ? qyxz[companyDetail.info].param_desc : companyDetail.tyc &&
            companyDetail.tyc.enter_type ? companyDetail.tyc.enter_type : "-" }}
          </div>
        </div>

        <div v-if="pmid != 220" class="row">
          <div class="td" style="width: 15%">单位地址</div>
          <div class="td" style="width: 55%; text-align: left">
            {{ companyDetail.address }}
          </div>
          <div class="td" style="width: 15%">邮政编码</div>
          <div class="td rltd" style="width: 15%">
            <el-input :disabled="!isEdit" v-model.trim="companyDetail.postal_code" placeholder="邮政编码" />
          </div>
        </div>
        <div v-if="pmid == 220" class="row">
          <div class="td" style="width: 15%">单位地址</div>
          <div class="td rltd" style="width: 85%; text-align: left">
            {{ companyDetail.address }}
          </div>
        </div>
        <div v-if="pmid != 220" class="row">
          <div class="td" style="width: 15%">单位联系部门</div>
          <div class="td" style="width: 15%; text-align: left">
            <el-input :disabled="!isEdit" v-model.trim="companyDetail.contact_dept" placeholder="单位联系部门" />
          </div>
          <div class="td" style="width: 15%">联系人</div>
          <div class="td" style="width: 25%">
            {{ companyDetail.firm_principal }}
          </div>
          <div class="td" style="width: 15%">电话</div>
          <div class="td rltd" style="width: 15%">{{ companyDetail.tel }}</div>
        </div>
        <div v-if="pmid == 220" class="row">
          <div class="td" style="width: 15%">联系人</div>
          <div class="td" style="width: 35%">
            {{ companyDetail.firm_principal }}
          </div>
          <div class="td" style="width: 15%">电话</div>
          <div class="td rltd" style="width: 35%">{{ companyDetail.tel }}</div>
        </div>
        <div v-if="pmid != 220" class="row">
          <div class="td" style="width: 15%">传 真</div>
          <div class="td" style="width: 15%; text-align: left">
            <el-input :disabled="!isEdit" v-model.trim="companyDetail.fax" placeholder="传真" />
          </div>
          <div class="td" style="width: 15%">电子邮箱</div>
          <div class="td" style="width: 25%">{{ companyDetail.email }}</div>
          <div class="td" style="width: 15%">参会人数</div>
          <div class="td rltd" style="width: 15%">
            <el-input :disabled="!isEdit" v-model.trim="companyDetail.num" placeholder="人数(填数字)" />
          </div>
        </div>
        <div v-if="pmid == 220" class="row">
          <div class="td" style="width: 15%">电子邮箱</div>
          <div class="td rltd" style="width: 85%">
            {{ companyDetail.email }}
          </div>
        </div>
        <div class="row">
          <div class="td" style="width: 15%; height: auto !important">企业简介</div>
          <div class="td rltd" style="width: 85%; text-align: left; display: inline-table; height: 136px">
            {{ companyDetail.job_desc }}
            <!-- <el-input type="textarea" :autosize="{ minRows: 6, maxRows: 10 }" v-model.trim="companyDetail.job_desc"
            placeholder="企业简介" :disabled="showDisabled" /> -->
          </div>
        </div>
        <div class="row">
          <div class="td rltd" style="width: 100%">参会代表情况</div>
        </div>
        <div v-if="pmid != 220" class="row">
          <div class="td" style="width: 20%">姓名</div>
          <div class="td" style="width: 20%">性别</div>
          <div class="td" style="width: 20%">职务</div>
          <div class="td" style="width: 20%">办公电话</div>
          <div class="td rltd" style="width: 20%; position: relative">
            移动电话
            <span style="margin-left: 10px; position: absolute; right: -30px; color: orangered; cursor: pointer">
              <i class="el-icon-circle-plus-outline" style="font-size: 25px" @click="addChryOne"></i>
            </span>
          </div>
        </div>
        <div v-if="pmid == 220" class="row">
          <div class="td" style="width: 25%">姓名</div>
          <div class="td" style="width: 25%">性别</div>
          <div class="td" style="width: 25%">职务</div>
          <div class="td rltd" style="width: 25%; position: relative">
            移动电话
            <span style="margin-left: 10px; position: absolute; right: -30px; color: orangered; cursor: pointer">
              <i class="el-icon-circle-plus-outline" style="font-size: 25px" @click="addChryOne"></i>
            </span>
          </div>
        </div>
        <div v-if="pmid != 220" class="row chdb" v-for="(item, idx) in dbList" :key="idx + 100">
          <div class="td" style="width: 20%">
            <el-input :disabled="!isEdit" size="mini" v-model="item.name" placeholder="姓名"></el-input>
          </div>
          <div class="td" style="width: 20%">
            <el-radio :disabled="!isEdit" size="mini" v-model="item.sex" label="1">男</el-radio>
            <el-radio :disabled="!isEdit" size="mini" v-model="item.sex" label="2">女</el-radio>
          </div>
          <div class="td" style="width: 20%">
            <el-input :disabled="!isEdit" size="mini" v-model="item.job" placeholder="职务"></el-input>
          </div>
          <div class="td" style="width: 20%">
            <el-input :disabled="!isEdit" size="mini" v-model="item.officePhone" placeholder="办公电话"></el-input>
          </div>
          <div class="td rltd" style="width: 20%">
            <el-input :disabled="!isEdit" size="mini" v-model="item.mobilePhone" placeholder="移动电话"></el-input>
            <span style="margin-left: 10px; position: absolute; right: -30px; color: orangered; cursor: pointer">
              <el-popconfirm confirm-button-text="确定" cancel-button-text="取消" icon="el-icon-info" icon-color="red"
                title="确定删除吗？" @confirm="deleteDBOne(idx)">
                <i slot="reference" class="el-icon-remove-outline" style="font-size: 25px; margin-top: 5px"></i>
              </el-popconfirm>
            </span>
          </div>
        </div>
        <div v-if="pmid == 220" class="row chdb" v-for="(item, idx) in dbList" :key="idx + 100">
          <div class="td" style="width: 25%">
            <el-input :disabled="!isEdit" size="mini" v-model="item.name" placeholder="姓名"></el-input>
          </div>
          <div class="td" style="width: 25%">
            <el-radio size="mini" v-model="item.sex" label="1">男</el-radio>
            <el-radio size="mini" v-model="item.sex" label="2">女</el-radio>
          </div>
          <div class="td" style="width: 25%">
            <el-input :disabled="!isEdit" size="mini" v-model="item.job" placeholder="职务"></el-input>
          </div>
          <div class="td rltd" style="width: 25%">
            <el-input :disabled="!isEdit" size="mini" v-model="item.mobilePhone" placeholder="移动电话"></el-input>
            <span style="margin-left: 10px; position: absolute; right: -30px; color: orangered; cursor: pointer">
              <el-popconfirm confirm-button-text="确定" cancel-button-text="取消" icon="el-icon-info" icon-color="red"
                title="确定删除吗？" @confirm="deleteDBOne(idx)">
                <i slot="reference" class="el-icon-remove-outline" style="font-size: 25px; margin-top: 5px"></i>
              </el-popconfirm>
            </span>
          </div>
        </div>
        <div class="row">
          <div class="td rltd" style="width: 100%">毕业生需求信息登记表</div>
        </div>
        <div class="row">
          <div class="td" style="width: 20%">招聘职位</div>
          <div class="td" style="width: 20%">所需人数</div>
          <div class="td" style="width: 15%">专业要求</div>
          <div class="td" style="width: 15%">学历要求</div>
          <div class="td" style="width: 15%">外语要求</div>
          <div class="td rltd" style="width: 15%">计算机要求</div>
          <span style="margin-left: 10px; position: absolute; right: -30px; color: orangered; cursor: pointer">
            <i class="el-icon-circle-plus-outline" style="font-size: 25px" @click="addPostOne"></i>
          </span>
        </div>
        <div class="row chdb" v-if="wyyq.length > 0 && xlyq.length > 0 && jsjyq.length > 0"
          v-for="(item, idx) in gwList" :key="idx">
          <div class="td rltd" style="width: 20%">
            <el-input :disabled="!isEdit" size="mini" v-model="item.post" placeholder="招聘职位"></el-input>
          </div>
          <div class="td rltd" style="width: 20%">
            <el-input-number :disabled="!isEdit" :min="1" size="small" v-model="item.num"></el-input-number>
          </div>
          <div class="td rltd" style="width: 15%">
            <el-input :disabled="!isEdit" size="mini" v-model="item.specialty" placeholder="专业要求"></el-input>
            <!-- <a-select
              mode="multiple"
              :default-value="item.specialty"
              style="width: 100%"
              placeholder="请选择专业"
              @change="setMajor"
              :disabled="showDisabled"
            >
              <a-select-option
                v-for="(item1,idx1) in majorList"
                :key="(idx +''+idx1)"
                :value="item1"
              >{{ item1 }}</a-select-option>
            </a-select>-->
          </div>
          <div class="td rltd" style="width: 15%">
            <el-select :disabled="!isEdit" v-model="item.culture" filterable clearable placeholder="学历要求" size="small">
              <el-option v-for="item in xlyq" :key="item.value" :label="item.param_desc"
                :value="item.param_desc"></el-option>
            </el-select>
          </div>
          <div class="td rltd" style="width: 15%">
            <el-select :disabled="!isEdit" v-model="item.foreignLanguage" filterable clearable placeholder="外语要求"
              size="small">
              <el-option v-for="item in wyyq" :key="item.value" :label="item.param_desc"
                :value="item.param_desc"></el-option>
            </el-select>
          </div>
          <div class="td rltd" style="width: 15%">
            <el-select :disabled="!isEdit" v-model="item.computer" filterable clearable placeholder="计算机要求"
              size="small">
              <el-option v-for="item in jsjyq" :key="item.value" :label="item.param_desc"
                :value="item.param_desc"></el-option>
            </el-select>
            <span style="margin-left: 10px; position: absolute; right: -30px; color: orangered; cursor: pointer">
              <el-popconfirm confirm-button-text="确定" cancel-button-text="取消" icon="el-icon-info" icon-color="red"
                title="确定删除吗？" @confirm="deletePostOne(idx)">
                <i slot="reference" class="el-icon-remove-outline" style="font-size: 25px; margin-top: 5px"></i>
              </el-popconfirm>
            </span>
          </div>
        </div>

        <div v-if="companyDetail.status != ''" style="width: 1000px; margin-top: 20px">
          <div class="flexStart">
            审核结果：
            <span v-if="companyDetail.status == 0 || companyDetail.status == 1"
              style="color: #0050d0; font-size: 12px">审核中</span>
            <span v-if="companyDetail.status && companyDetail.status == 2"
              style="color: #009f95; font-size: 14px">审核通过</span>
            <span v-if="companyDetail.status && companyDetail.status == 3"
              style="color: orangered; font-size: 14px">审核不通过</span>
          </div>
          <div v-if="companyDetail.status && companyDetail.status == 3" style="color: orangered; font-size: 14px">
            不通过原因：{{ companyDetail.check_desc }}</div>
        </div>
      </div>

      <div slot="footer">
        <el-button type="success" v-if="companyDetail.status == 2" v-print="'#printMe'"
          icon="el-icon-download">导出回执单</el-button>
        <el-button v-if="isEdit" type="primary" icon="el-icon-check" @click="saveZph">提交审核</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
export default {
  name: "companInfo",
  components: {},
  data() {
    return {
      companyDetail: {
        status: 0,
        check_status: 0,
        check_desc: "",
        info: "",
        firm_name: "",
        address: "",
        postal_code: "",
        contact_dept: "",
        firm_principal: "",
        tel: "",
        fax: "",
        email: "",
        num: 1,
        job_desc: "",
      },
      dbList: [{ name: "", sex: "", job: "", officePhone: "", mobilePhone: "" }],
      gwList: [
        {
          post: "",
          num: "",
          specialty: "",
          culture: "",
          foreignLanguage: "",
          computer: "",
        },
      ],
      qyxz: [],
      xlyq: [],
      wyyq: [],
      jsjyq: [],
      companyInfo: {
        check_status: 0,
      },
      pmid: window.pmid,
      searchForm: {},
      tableData: [],
      page: {
        count: 0,
        current_page: 1,
        per_page: 50,
        total_page: 0,
      },
      dialogshow: false,
      isEdit: false,
      headerInfo: {},
      curYear:''
    };
  },
  watch: {
    dialogshow: function (val) {
      if (!val) {
        this.isEdit = false;
      }
    },
  },
  mounted() {
    this.curYear = new Date().getFullYear();
    this.getConfig()
    this.$http.post("/api/enterprise_info", {}).then((res) => {
      this.companyInfo = res.data;
    });
    this.getList();
    this.getComType().then((rr) => {
      this.getEnterInfo();
    });
  },
  methods: {
    getConfig() {
      if (this.$store.state.config && this.$store.state.config.schoolname) {
        let config = this.$store.state.config
        if (config.xxzph_header_info) {
          this.headerInfo = JSON.parse(config.xxzph_header_info)
        }
      } else {
        this.$http.post("/api/sch_configs").then(res => {
          let config = {}
          for (let k of res.data) {
            config[k.ktype] = k.kvalue
          }
          if (config.xxzph_header_info) {
            this.headerInfo = JSON.parse(config.xxzph_header_info)
          }
        });
      }
      // console.log(592, this.headerInfo)
    },
    getComType() {
      return new Promise((resolve) => {
        this.$http
          .post("/api/sys_param_list", {
            param_type: "'ENTER_INFO','EDUACTION','ENGLISH_LEVEL','COMPUTER_LEVEL'",
            used: 0,
          })
          .then((res) => {
            let qyxz = []; //企业性质
            let xlyq = []; //学历类型
            let wyyq = []; //外语要求
            let jsjyq = []; //计算机要求
            for (let item of res.data) {
              if (item.param_type == "ENTER_INFO") {
                qyxz.push(item);
              }
              if (item.param_type == "EDUACTION") {
                xlyq.push(item);
              }
              if (item.param_type == "ENGLISH_LEVEL") {
                wyyq.push(item);
              }
              if (item.param_type == "COMPUTER_LEVEL") {
                jsjyq.push(item);
              }
            }
            this.qyxz = qyxz;
            this.xlyq = xlyq;
            this.wyyq = wyyq;
            this.jsjyq = jsjyq;
            resolve();
          });
      });
    },
    getList() {
      this.$http
        .post("/api/enterprise_job_fair_list", {
          year: this.searchForm.year,
          status: this.searchForm.status,
        })
        .then((res) => {
          res.data.data.map((item) => {
            if (item.create_date) {
              let arr = item.create_date.split("-");
              item.year = arr[0];
            }
            if (item.delegates) {
              item.delegates = JSON.parse(item.delegates);
            }
            if (item.job_info_list) {
              item.job_info_list = JSON.parse(item.job_info_list);
            }
          });
          this.tableData = res.data.data;
          this.page = res.data.page;
          console.log(res.data.data);
        });
    },
    checkData(year) {
      return new Promise((resolve, reject) => {
        this.$http
          .post("/api/enterprise_job_fair_list", { year: year })
          .then((res) => {
            resolve(res.data.data.length || 0);
          })
          .catch((err) => {
            resolve(0);
          });
      });
    },
    add() {
      let year = new Date().getFullYear();
      this.checkData(year).then((len) => {
        let istj = this.pmid == 220 ? len > 1 : len >  0
        if (istj) {
          this.$message({
            type: "error",
            duration: 5000,
            message: `${year}年度已提交线下招聘会申请，无需新增，请在该年度数据上进行编辑修改~`,
          });
        } else {
          let companyDetail = JSON.parse(JSON.stringify(this.companyDetail));
          companyDetail.status = "";
          companyDetail.id = "";
          this.companyDetail = companyDetail;
          this.dbList = [{ name: "", sex: "", job: "", officePhone: "", mobilePhone: "" }];
          this.gwList = [
            {
              post: "",
              num: "",
              specialty: "",
              culture: "",
              foreignLanguage: "",
              computer: "",
            },
          ];
          this.isEdit = true;
          this.dialogshow = true;
        }
      });
    },
    edit(row) {
      this.getEnterInfo(row.id);
      this.isEdit = true;
      this.dialogshow = true;
    },
    linkExportPage() { }, //导出回执单
    addChryOne() {
      this.dbList.push({
        name: "",
        sex: "",
        job: "",
        officePhone: "",
        mobilePhone: "",
      });
    },
    addPostOne() {
      this.gwList.push({
        post: "",
        num: "",
        specialty: "",
        culture: "",
        foreignLanguage: "",
        computer: "",
      });
    },
    saveZph() {
      this.companyDetail.job_info_list = this.gwList;
      this.companyDetail.delegates = this.dbList;
      this.$http.post("/api/zp_job_fair_edit", this.companyDetail).then((res) => {
        this.$message({
          type: "success",
          message: "提交审核成功，请耐心等待审核！",
        });
        this.dialogshow = false;

        this.getList();
      });
    },
    deleteDBOne(idx) {
      this.dbList.splice(idx, 1);
    },
    deletePostOne(idx) {
      this.gwList.splice(idx, 1);
    },
    view(row) {
      console.log(row.id);
      this.getEnterInfo(row.id);
      this.isEdit = false;
      this.dialogshow = true;
    },
    getEnterInfo(id) {
      this.$http.post("/api/zp_job_fair_from", { id: id }).then((res) => {
        if (res.data.create_date) {
          let arr = res.data.create_date.split("-");
          res.data.year = arr[0];
        }
        if (res.data.job_info_list) {
          this.gwList = res.data.job_info_list;
        }
        if (res.data.delegates) {
          this.dbList = res.data.delegates;
        }

        if (!this.companyDetail.job_desc) {
          //enterprise_info
          this.$http.post("/api/enterprise_info", {}).then((res2) => {
            this.companyDetail.job_desc = res2.data.enter_desc;
            if (res2.data.tyc) {
              this.companyDetail.tyc = res2.data.tyc;
            }
          });
        }

        this.companyDetail = res.data;

        // this.$http.post("/api/tyc_search", {enter_name:this.companyDetail.firm_name}).then(res2 => {
        //   this.companyDetail.info =res2.data.companyOrgType
        // });
      });
    },
    handlePageChange(page) {
      this.page.current_page = page;
      this.getList();
    },
    handleSizeChange(val) {
      this.page.current_page = 1;
      this.page.per_page = val;
      this.getList(1);
    },
  },
};
</script>

<style lang="less" type="text/less">
.row {
  border-bottom: 1px solid #ccc;
  width: 100%;
  min-height: 40px;
  text-align: center;
  display: flex;
  position: relative;
}

.td {
  border-left: 1px solid #ccc;
  padding: 10px;
  box-sizing: border-box;
  vertical-align: top;
  min-height: 52px;
  line-height: 32px;
  word-break: break-all;
}

.rltd {
  border-right: 1px solid #ccc;
}

.zphPage {
  .el-input.is-disabled .el-input__inner {
    color: #606266;
  }
}
</style>
<style lang="less" type="text/less" scoped>
.zphPage {
  /* margin: 0 0 0 15px; 
  width: calc(100% - 15px);
  background-color: #ffffff;*/
  overflow-y: auto;
  font-size: 14px;
  color: #303133;
  position: relative;

  .exportBtn {
    position: absolute;
    top: 20px;
    float: left;
  }

  ul,
  li {
    list-style: none;

    outline: none;
  }

  .list-items {
    width: 100%;
    margin: 5px 0 0 0;
    padding: 0;
    list-style: none;

    outline: none;

    .list-item {
      background-color: #fff;
      padding: 24px !important;
      border: 0;
      margin-bottom: 12px;
      outline: none;
      box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.1);

      @media screen and (min-width: 750px) {
        .list-content {
          width: 50%;
        }
      }

      .list-content {
        .name {
          font-size: 18px;
          margin-bottom: 8px;
          margin-top: 0;
          color: #303133;

          span {
            font-size: 14px;
            padding: 1px 5px;
            border-radius: 4px;
            border: 1px solid #303133;
            margin-left: 5px;
          }

          .style0 {
            color: #3378fa;
            border-color: #3378fa;
          }

          .style1 {
            color: #19c295;
            border-color: #19c295;
          }

          .style2 {
            color: #ef342e;
            border-color: #ef342e;
          }

          .style3 {
            color: #c0c4cc;
            border-color: #c0c4cc;
          }
        }

        .name1 {
          color: #909399 !important;
        }
      }

      .sendNum {
        width: 140px;
        cursor: pointer;

        span {
          font-size: 18px;
        }
      }

      .createdTime {
        color: #909399;
        font-size: 14px;
      }

      .list-item-action {
        width: 90px;
        margin-left: 30px;
        margin-bottom: 0;
        text-align: right;
        -webkit-box-flex: 0;
        flex: 0 0 auto;
        padding: 0;
        font-size: 0;
        list-style: none;

        li:first-child {
          padding-left: 0;
        }

        li {
          position: relative;
          display: inline-block;
          padding: 0 8px;
          color: rgba(0, 0, 0, 0.45);
          font-size: 14px;
          line-height: 22px;
          text-align: center;
          cursor: pointer;
          outline: none;
          box-sizing: border-box;
        }

        a {
          color: #3378fa;
          -webkit-transition: all 0.3s;
          transition: all 0.3s;
          touch-action: manipulation;
          background-color: transparent;
          cursor: pointer;
          text-decoration: none;
          outline: none;
          font-size: 14px;
        }

        .list-item-action-split {
          position: absolute;
          top: 50%;
          right: 0;
          width: 1px;
          height: 14px;
          margin-top: -7px;
          background-color: #e8e8e8;
        }
      }
    }
  }
}

.dttable td {
  border-color: #000;
}
</style>
<style media="print">
@page {
  size: auto;
  /* auto is the initial value */
  margin: 3mm;
  /* this affects the margin in the printer settings */
}
</style>
